import Swiper from "swiper/bundle";

jQuery(document).ready(function ($) {
  // Function to initialize Swiper instances and bind controls
  var thumbSwiperElement = $(".rtwpvg-thumbnail-slider")[0];

  //Remove the stacked thumbnail during the initial load with d-none class
  var initializeAndBindSwipers = function () {
    var mainSwiperElement = $(".rtwpvg-slider")[0];

    let mainSwiperCustomButtonDiv = document.querySelector(
      ".product-variations-custom-swiper-navigation"
    );

    //If slide image is just one then hide the main slider button
    if (mainSwiperElement) {
      const realSlideCount = mainSwiperElement.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate)"
      ).length;
      if (realSlideCount <= 1) {
        $(".variations-swiper-prev, .variations-swiper-next").hide();
      } else {
        $(".variations-swiper-prev, .variations-swiper-next").show();
      }
    }

    //Initialize Main Swiper if not already
    let mainSwiperInstance = mainSwiperElement?.swiper;
    if (!mainSwiperInstance && mainSwiperElement) {
      const mainOptions = JSON.parse(mainSwiperElement.dataset.options);
      mainOptions.navigation = {
        nextEl: ".variations-swiper-next",
        prevEl: ".variations-swiper-prev",
        disabledClass: "swiper-button-disabled",
      };
      mainSwiperInstance = new Swiper(mainSwiperElement, mainOptions);

      if (mainSwiperInstance.navigation) {
        mainSwiperInstance.navigation.update();
      }
    }
    if (!mainSwiperInstance) return;

    //Initialize Thumbnail Swiper if not already
    let thumbSwiperInstance = thumbSwiperElement?.swiper;
    if (!thumbSwiperInstance && thumbSwiperElement) {
      const thumbOptions = JSON.parse(thumbSwiperElement.dataset.options);

      // Important: Override/ensure essential Swiper options for thumbnails
      thumbOptions.slidesPerView = thumbOptions.breakpoints["0"].slidesPerView || 3;
      thumbOptions.slidesPerGroup = thumbOptions.breakpoints["0"].slidesPerGroup || 1;
      thumbOptions.spaceBetween = 10;
      thumbOptions.loop = false;
      thumbOptions.freeMode = true;
      thumbOptions.watchSlidesProgress = true;
      thumbOptions.watchSlidesVisibility = true;

      thumbOptions.navigation = {
        nextEl: ".thumbnail-gallery-swiper-next",
        prevEl: ".thumbnail-gallery-swiper-prev",
        disabledClass: "swiper-button-disabled",
      };

      thumbSwiperInstance = new Swiper(thumbSwiperElement, thumbOptions);
    }

    //Update navigation button states for main swiper
    var updateMainNavigationState = function () {
      const $prevBtn = $(".variations-swiper-prev");
      const $nextBtn = $(".variations-swiper-next");

      // Remove disabled class first
      $prevBtn.removeClass("swiper-button-disabled");
      $nextBtn.removeClass("swiper-button-disabled");

      if (mainSwiperInstance.isBeginning) {
        $prevBtn.addClass("swiper-button-disabled");
      }

      if (mainSwiperInstance.isEnd) {
        $nextBtn.addClass("swiper-button-disabled");
      }
    };

    //Update navigation button states for thumbnail swiper
    var updateThumbnailNavigationState = function () {
      if (!thumbSwiperInstance) return;

      const $prevBtn = $(".thumbnail-gallery-swiper-prev");
      const $nextBtn = $(".thumbnail-gallery-swiper-next");

      // Remove disabled class first
      $prevBtn.removeClass("swiper-button-disabled");
      $nextBtn.removeClass("swiper-button-disabled");

      if (thumbSwiperInstance.isBeginning) {
        $prevBtn.addClass("swiper-button-disabled");
      }

      if (thumbSwiperInstance.isEnd) {
        $nextBtn.addClass("swiper-button-disabled");
      }
    };

    //Helper to update the thumbnails' active state based on the main slider
    var updateThumbnailsActiveState = function () {
      var thumbs = $(".rtwpvg-thumbnail-image");
      thumbs.removeClass("swiper-slide-thumb-active");

      var activeIndex = mainSwiperInstance.realIndex;
      var activeThumb = thumbs.eq(activeIndex);
      if (activeThumb.length) {
        activeThumb.addClass("swiper-slide-thumb-active");

        // If thumbnail swiper exists, make sure the active thumbnail is in view
        if (thumbSwiperInstance) {
          thumbSwiperInstance.slideTo(activeIndex);
        }
      }
    };

    //Main Slider Navigation
    $(".variations-swiper-prev")
      .off("click")
      .on("click", function () {
        if (!$(this).hasClass("swiper-button-disabled")) {
          mainSwiperInstance.slidePrev();
          updateThumbnailsActiveState();
          // Updating navigation state after slide
          setTimeout(() => {
            updateMainNavigationState();
          }, 50);
        }
      });

    $(".variations-swiper-next")
      .off("click")
      .on("click", function () {
        if (!$(this).hasClass("swiper-button-disabled")) {
          mainSwiperInstance.slideNext();
          updateThumbnailsActiveState();
          // Update navigation state after slide
          setTimeout(() => {
            updateMainNavigationState();
          }, 50);
        }
      });

    // Listen for slide change events to update navigation states
    mainSwiperInstance.off("slideChange").on("slideChange", function () {
      updateThumbnailsActiveState();
      updateMainNavigationState();
    });

    // Listen for transition end to ensure states are updated correctly
    mainSwiperInstance.off("transitionEnd").on("transitionEnd", function () {
      updateMainNavigationState();
    });

    if (thumbSwiperInstance) {
      $(".thumbnail-gallery-swiper-prev")
        .off("click")
        .on("click", function () {
          if (!$(this).hasClass("swiper-button-disabled")) {
            thumbSwiperInstance.slidePrev();
            // Update navigation state after slide
            setTimeout(() => {
              updateThumbnailNavigationState();
            }, 50);
          }
        });

      $(".thumbnail-gallery-swiper-next")
        .off("click")
        .on("click", function () {
          if (!$(this).hasClass("swiper-button-disabled")) {
            thumbSwiperInstance.slideNext();
            // Update navigation state after slide
            setTimeout(() => {
              updateThumbnailNavigationState();
            }, 50);
          }
        });

      // Listen for thumbnail swiper events
      thumbSwiperInstance.off("slideChange").on("slideChange", function () {
        updateThumbnailNavigationState();
      });

      thumbSwiperInstance.off("transitionEnd").on("transitionEnd", function () {
        updateThumbnailNavigationState();
      });

      $(".rtwpvg-thumbnail-image")
        .off("click")
        .on("click", function () {
          var clickedIndex = $(this).index();
          if (mainSwiperInstance.params.loop) {
            mainSwiperInstance.slideToLoop(clickedIndex);
          } else {
            mainSwiperInstance.slideTo(clickedIndex);
          }
        });
    }

    // Initial updates
    updateThumbnailsActiveState();
    updateMainNavigationState();
    updateThumbnailNavigationState();
  };

  setTimeout(() => {
    initializeAndBindSwipers();
  }, 500);

  // Re-initialize and bind after variation is loaded
  $("form.variations_form").on("found_variation", function () {
    setTimeout(() => {
      initializeAndBindSwipers();
    }, 200);
  });

  const navButtons = document.querySelector(
    ".product-variations-custom-swiper-navigation"
  );
  const thumbnailSlideButtons = document.querySelector(
    ".product-thumbnail-gallery-custom-swiper-navigation"
  );
  const sliderWrapper = document.querySelector(".rtwpvg-slider-wrapper");
  const thumbnailSlideWrapper = document.querySelector(
    ".rtwpvg-thumbnail-wrapper"
  );

  if (navButtons && sliderWrapper) {
    sliderWrapper.appendChild(navButtons);
    navButtons.classList.remove("d-none");
  }

  if (thumbnailSlideButtons && thumbnailSlideWrapper) {
    thumbnailSlideWrapper.appendChild(thumbnailSlideButtons);
    thumbnailSlideButtons.classList.remove("d-none");
  }
});
